export default {
    showErrorMessage: function (message) {
        const self = this

        self.errorMessage.content = message
        self.errorMessage.show = true
    },

    showSuccessMessage: function (message) {
        const self = this

        self.successMessage.content = message
        self.successMessage.show = true
    }
}
